/**
 * Business Logic for Configuration Module
 * @param {} state 
 * @returns 
 */

import { activeProfileComfortOnly, activeProfileFull } from "../../../utility/MenuOptions"

const processAHITypeSelection = (state) => {
  switch (state.selectedConfiguration.settings.ahiType) {
    case 0: case 2:
      state.selectedConfigurationRanges.maxCadenceRange = {
        min: 60,
        max: 90
      }
      state.activeProfile = activeProfileComfortOnly.map(profile => profile)
      state.selectedConfiguration.settings.activeProfile = activeProfileComfortOnly[0].value || null
      break

    case 1: case 3: case 4: case 5:
      state.selectedConfigurationRanges.maxCadenceRange = {
        min: 60,
        max: 120
      }
      state.activeProfile = activeProfileFull.map(profile => profile)
      break

    default:
      break
  }
}

const validateMaxCadenceValue = (state) => {
  const CR = state.selectedConfigurationRanges.maxCadenceRange
  const CMC = state.selectedConfiguration.settings.maxCadence
  const CSPR = state.selectedConfigurationRanges.cadenceSetPointRange
  CSPR.max = CSPR.max > CR.max ? CR.max : CSPR.max
  state.selectedConfiguration.settings.maxCadence = CMC > CR.max ? CR.max : CMC
  state.selectedConfigurationRanges.cadenceSetPointRange = CSPR
}

const validateCadenceSetPointValue = (state) => {
  const CR = state.selectedConfigurationRanges.maxCadenceRange
  const CSP = state.selectedConfiguration.settings.cadenceSetPoint
  /** if setpoint smaller then min? set to min */
  state.selectedConfiguration.settings.cadenceSetPoint = CSP < CR.min ? CR.min : CSP
  /** else if setpoint larger then max? set to max */
  state.selectedConfiguration.settings.cadenceSetPoint = CSP > CR.max ? CR.max : CSP
}

export const businessLogic = (state) => {
  processAHITypeSelection(state)
  validateMaxCadenceValue(state)
  validateCadenceSetPointValue(state)
  return state
}
